import React from 'react'

const CustomError = ({text,style}) => {
  return (
    <>
      <small 
      className="p-error text-danger" 
      style={style ||{}}
      >
        {text}
    </small>
    </>
  )
}

export default CustomError
